import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  Save,
  MailOutline,
  WhatsApp,
  Store,
  PercentOutlined,
} from "@mui/icons-material";
import {
  Grid,
  TextField,
  FormControl,
  Snackbar,
  Slide,
  Alert,
} from "@mui/material";
import FileBase64 from "react-file-base64";
import Resizer from "react-image-file-resizer";

import LoadStates from "components/services/LoadStates";
import LoadCities from "components/services/LoadCities";
import imgLoader from "assets/img/loading.gif";
import img from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      300,
      300,
      "PNG",
      15,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

const useStyles = makeStyles(cardBodyStyle);

export default function EditCompanyAdmin(props) {
  const classes = useStyles();

  const [openAlert, setOpenAlert] = useState(false);
  const [loader, setLoader] = useState(true);
  const [mensaje, setMensaje] = useState("");
  const [errorAlert, setErrorAlert] = useState("");
  const [loaders, setLoaders] = useState(false);
  const [disabledCities, setDisabledCities] = useState(false);
  const [error, setError] = useState("");
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = useState(false);

  const { urlServices, UserAuth, UpdateUserAuth } =
    useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    document_id: "",
    name: "",
    email: "",
    phone: "",
    states: "",
    statesData: "",
    cities: "",
    citiesData: "",
    direccion: "",
    percentage: "",
    picture: "",
    pictureBase64: "",
    errorDocument: false,
    errorName: false,
    errorEmail: false,
    errorPhone: false,
    errorStates: false,
    errorCities: false,
    errorDireccion: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Scroll to top smoothly
        window.scrollTo({ top: 0, behavior: "smooth" });

        const response = await axios.get(
          `${urlServices}company/${UserAuth.companyId}`,
          {
            headers: {
              Authorization: "Bearer " + keyAuthorization,
            },
          }
        );

        setValues({
          ...values,
          document_id: response.data.company.nRuc,
          name: response.data.company.name,
          email: response.data.company.email,
          phone: response.data.company.phone,
          states: response.data.company.provinceId,
          statesData:
            response.data.company.provinceId !== null
              ? {
                  id: response.data.company.provinceId,
                  name: response.data.company.province.name,
                }
              : null,
          cities: response.data.company.cityId,
          citiesData:
            response.data.company.cityId !== null
              ? {
                  id: response.data.company.cityId,
                  name: response.data.company.cities.name,
                }
              : null,
          direccion: response.data.company.direccion,
          percentage: response.data.company.cashDiscount,
          picture: response.data.company.logo,
        });

        setLoader(false);
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            setMensageSystem(
              "La sesión ha expirado, vuelva a iniciar sesión ..."
            );
            setError(true);

            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 4000);
          } else if (error.response.status === 500) {
            setMensageSystem("Error en la consulta con el servidor.");
            setError(true);
          }
        } else {
          console.error("Error fetching company data:", error);
        }
      }
    };

    fetchData();
  }, []);

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
      errorDocument: false,
      errorEmail: false,
      errorPhone: false,
      errorDireccion: false,
    });
    setOpenAlert(false);
  };

  const submitForm = () => {
    setOpenAlert(false);
    setError(false);

    if (values.name.length === 0) {
      setValues({ ...values, errorName: true });
      setMensaje('El campo "Nombre" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setMensaje('El campo "Correo Electrónico" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else if (values.states === "") {
      setValues({ ...values, errorStates: true });
      setMensaje('El campo "Provincias" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else if (values.cities === "") {
      setValues({ ...values, errorCities: true });
      setMensaje('El campo "Ciudad" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else if (values.direccion.length === 0) {
      setValues({ ...values, errorDireccion: true });
      setMensaje('El campo "Dirección" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else if (values.phone.length === 0) {
      setValues({ ...values, errorPhone: true });
      setMensaje('El campo "Número de whatsapp" es obligatorio.');
      setOpenAlert(true);
      setErrorAlert("error");
    } else {
      setOpenAlert(false);
      setLoaders(true);

      const dataValue = {
        name: values.name,
        nRuc: values.document_id,
        provinceId: values.states,
        cityId: values.cities,
        direccion: values.direccion,
        email: values.email,
        phone: values.phone,
        cashDiscount: values.percentage === "" ? null : values.percentage,
      };

      if (values.pictureBase64 !== "") {
        dataValue.logo = values.pictureBase64;
      }else{
        dataValue.logo = values.picture; 
      }

      axios
        .put(`${urlServices}company/${UserAuth.companyId}`, dataValue, {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        })
        .then((response) => {
          setOpenAlert(true);
          setMensaje(response.data.message);
          UpdateUserAuth({
            cashDiscount: values.percentage,
            logo:
              values.pictureBase64 !== ""
                ? values.pictureBase64
                : UserAuth.logo,
          });
          setErrorAlert("success");
          setLoaders(false);
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setMensageSystem(
              "La sesión ha expirado, vuelva a iniciar sesión ..."
            );
            setError(true);

            setTimeout(() => {
              localStorage.clear();
              setReturnLogin(true);
            }, 4000);
          } else if (e.response.status === 500) {
            setMensageSystem("Error en la consulta con sel servidor.");
            setError(true);
          }
        });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenAlert(false);
  };

  const changeStates = (data) => {
    setValues({
      ...values,
      states: data !== null ? data.id : "",
      statesData: data !== null ? data : "",
      errorStates: false,
      cities: "",
      citiesData: "",
    });

    setDisabledCities(data !== null ? false : true);
    setOpenAlert(false);
  };

  const changeCities = (data) => {
    setValues({
      ...values,
      cities: data !== null ? data.id : "",
      citiesData: data !== null ? data : "",
      errorCities: false,
    });

    setOpenAlert(false);
  };

  const changeDeleteLogo = () => {
    setValues({
      ...values,
      picture: "",
      pictureBase64: "",
    });
  };

  const uploadSingleFile = async (e) => {
    let image = "",
      outfile = "";

    // Single file
    if (Number(e.file.size) > 30000) {
      // SI ES MAYOR A 500KB LE BAJAMOS EL PESO
      image = await resizeFile(e.file);
      // const newFile = dataURIToBlob(image);
      outfile = image;
    } else {
      outfile = e.base64;
    }
    setValues({ ...values, pictureBase64: outfile });

    // Multiples files
    // if (e.length > 0 && e.length <= 1) {
    //   if (Number(e[0].file.size) > 500000) {
    //     // SI ES MAYOR A 500KB LE BAJAMOS EL PESO
    //     image = await resizeFile(e[0].file)
    //     // const newFile = dataURIToBlob(image);
    //     outfile = image
    //   } else {
    //     outfile = e[0].base64
    //   }
    //   setValues({ ...values, pictureBase64: outfile })
    // }
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Grid container spacing={1} style={{ marginBottom: 25 }}>
        <Grid item xs={12} sm={12}>
          {error && <Alert severity="error">{mensageSystem}</Alert>}
          <div className={classes.cardTitleBlack}>
            <Store className={classes.iconFilter} /> Actualización de datos
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={1} className={classes.containerProfile}>
        {loader ? (
          <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
            <img
              src={imgLoader}
              alt="loader"
              style={{
                width: 60,
                objectFit: "contain",
                marginTop: 25,
              }}
            />
          </Grid>
        ) : (
          <Fragment>
            <Grid item xs={12} sm={12} sx={{ m: "5px 0" }}>
              <b style={{ color: "#000" }}>Logo de la Empresa</b>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid
                container
                spacing={1}
                className={classes.containerProfile}
                sx={{ background: "#F6F6F6" }}
              >
                <Grid item xs={12} sm={12}>
                  <center>
                    <img
                      alt="avatar"
                      src={values.pictureBase64 || values.picture || img}
                      className={classes.imgUserProfile}
                    />
                    <br></br>
                    <Grid container spacing={1}>
                      <Grid
                        item
                        xs={values.picture || values.pictureBase64 ? 6 : 12}
                        sm={values.picture || values.pictureBase64 ? 6 : 12}
                      >
                        <label
                          className={classes.buttonSubmit2}
                          style={{ float: values.picture || values.pictureBase64 ? "right" : "none", width: 100 }}
                        >
                          <FileBase64
                            type="file"
                            multiple={false}
                            onDone={uploadSingleFile}
                          />
                          <i className="fa fa-cloud-upload"></i>&nbsp;&nbsp;
                          {values.picture || values.pictureBase64
                            ? "Cambiar imagen"
                            : "Seleccionar imagen"}
                        </label>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        sx={{
                          display:
                            values.picture || values.pictureBase64
                              ? "block"
                              : "none",
                        }}
                      >
                        <label
                          className={classes.buttonSubmit2}
                          style={{ float: "left", width: 100, background: "red" }}
                          onClick={changeDeleteLogo}
                        >
                          <i className="fa fa-close"></i>&nbsp;&nbsp; Eliminar
                          logo
                        </label>
                      </Grid>
                    </Grid>
                  </center>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} sx={{ m: "5px 0" }}>
                  <b style={{ color: "#000" }}>Datos de la Empresa</b>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl style={{ width: "100%" }}>
                    <TextField
                      name="document_id"
                      value={values.document_id}
                      error={values.errorDocument}
                      onChange={handleChange("document_id")}
                      fullWidth
                      required
                      label="Nro. Ruc"
                      margin="dense"
                      variant="outlined"
                      autoComplete="off"
                      inputProps={{
                        style: {
                          textAlign: "left",
                        },
                        maxLength: 13,
                      }}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");
                      }}
                      style={{ background: "#FFFFFF" }}
                      size="small"
                      disabled
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    autoComplete="off"
                    name="name"
                    value={values.name}
                    onChange={handleChange("name")}
                    label="Nombre de la empresa"
                    error={values.errorName}
                    fullWidth
                    required
                    margin="dense"
                    variant="outlined"
                    style={{ background: "#FFFFFF" }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="off"
                    name="email"
                    value={values.email}
                    onChange={handleChange("email")}
                    label="Correo electrónico de la empresa"
                    error={values.errorEmail}
                    fullWidth
                    required
                    margin="dense"
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <MailOutline
                          fontSize="small"
                          className={classes.iconInput}
                          position="end"
                        ></MailOutline>
                      ),
                    }}
                    style={{ background: "#FFFFFF" }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LoadStates
                    value={values.statesData}
                    refresh={changeStates}
                    idCountries={45}
                    error={values.errorStates}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="off"
                    name="phone"
                    value={values.phone}
                    onChange={handleChange("phone")}
                    label="Número de Whatsapp"
                    fullWidth
                    required
                    InputProps={{
                      endAdornment: (
                        <WhatsApp
                          fontSize="small"
                          className={classes.iconInput}
                          position="end"
                        ></WhatsApp>
                      ),
                    }}
                    inputProps={{
                      maxLength: 12,
                    }}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    margin="dense"
                    variant="outlined"
                    error={values.errorPhone}
                    style={{ background: "#FFFFFF" }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <LoadCities
                    value={values.citiesData}
                    refresh={changeCities}
                    disabled={disabledCities}
                    idStates={values.states}
                    error={values.errorCities}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="off"
                    name="direccion"
                    value={values.direccion}
                    onChange={handleChange("direccion")}
                    label="Dirección de funcionamiento"
                    fullWidth
                    required
                    margin="dense"
                    variant="outlined"
                    error={values.errorDireccion}
                    style={{ background: "#FFFFFF" }}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} sx={{ mt: 2, mb: 2 }}>
                <b style={{ color: "#000" }}>Configuración</b>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl style={{ width: "70%" }}>
                  <TextField
                    name="percentage"
                    value={values.percentage}
                    onChange={handleChange("percentage")}
                    fullWidth
                    required
                    size="small"
                    label="Porcentaje de descuento al contado"
                    margin="dense"
                    variant="outlined"
                    autoComplete="off"
                    inputProps={{
                      style: {
                        textAlign: "center",
                      },
                      maxLength: 3,
                    }}
                    type="number"
                    InputProps={{
                      endAdornment: (
                        <PercentOutlined
                          fontSize="small"
                          className={classes.iconInput}
                          position="end"
                        ></PercentOutlined>
                      ),
                    }}
                    //  helperText="Si no se sabe el porcentaje de la comisión, colocar 0."
                  />
                  <Alert severity="info" sx={{ fontSize: 12 }}>
                    El porcentaje de descuento si un cliente paga al contado.
                  </Alert>
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} md={12}>
              {loaders ? (
                <center>
                  <img
                    src={imgLoader}
                    alt="loader"
                    style={{
                      width: 60,
                      objectFit: "contain",
                      marginTop: 25,
                    }}
                  />
                </center>
              ) : (
                <div style={{ float: "right" }}>
                  <ButtonStyle0 onClick={submitForm} endIcon={<Save />}>
                    Actualizar datos
                  </ButtonStyle0>
                </div>
              )}
            </Grid>
          </Fragment>
        )}
      </Grid>
      <Snackbar
        open={openAlert}
        autoHideDuration={20000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={handleClose}
      >
        <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
          <Alert
            onClose={handleClose}
            severity={errorAlert === "error" ? "error" : "success"}
            elevation={6}
            variant="filled"
          >
            {mensaje}
          </Alert>
        </Slide>
      </Snackbar>
    </Fragment>
  );
}
